import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=c15d35ae&scoped=true&"
import script from "./ReportsView.vue?vue&type=script&lang=js&"
export * from "./ReportsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15d35ae",
  null
  
)

export default component.exports